import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, Center, Stack, Heading, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
export default function Jackpot() {
  return /*#__PURE__*/_jsx(Center, {
    children: /*#__PURE__*/_jsx(Stack, {
      spacing: "80px",
      children: /*#__PURE__*/_jsxs(Stack, {
        textAlign: "center",
        spacing: "5",
        children: [/*#__PURE__*/_jsxs(Heading, {
          fontWeight: 900,
          children: ["Stop chasing articles,", ' ', /*#__PURE__*/_jsx(Text, {
            as: "span",
            color: "blue.500",
            children: "we got you."
          })]
        }), /*#__PURE__*/_jsx(Text, {
          children: "You don't have to check with your researchers about new " + 'publications. Let Articali do the heavy lifting and find ' + 'new articles for you. No more going through email and ' + 'endless list. Articali finds the latest publication ' + 'without you having to do anything. Just use the freed time wisely! '
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(NextLink, {
            href: "/demo",
            passHref: true,
            children: /*#__PURE__*/_jsx(Button, {
              colorScheme: "primaryOrange",
              children: "See Demo Hub"
            })
          })
        })]
      })
    })
  });
}